import I18n from '../classes/translations';

export default class Datatable {
	constructor() {
		this.selector = '.js-datatable';
		this.$table = $(this.selector);
		this.datatable = '';

		this.initialize();
	}

	defaultDatatableInit() {
		if (this.$table.length) {

			this.datatable = this.$table.mDatatable({
				translate: this._translation()
			});

			this._defaultSearch();
			this._selectPicker();
		}
	}

	_defaultSearch() {
		const that = this;
		const $search = $('.js-datatable-search');

		if ($search.length) {
			$search.on('keyup', function () {
				that.datatable.search($(this).val().toLowerCase());
			}).val(this._query().generalSearch);
		}
	}

	_selectPicker() {
		const that = this;
		const $selectpickers = $('.js-datatable-selectpicker');

		if ($selectpickers.length) {
			$selectpickers.each(function () {
				const $selectpicker = $(this);

				$selectpicker.on('change', function () {
					const $selected = $selectpicker.find('option:selected');

					if ($selected.length && parseInt($selected.val()) !==  0) {
						that.datatable.search($selected.text().toLowerCase());
					} else {
						that.datatable.search('');
					}
				}).val(that._query().generalSearch);
			});
		}
	}

	_query() {
		return this.datatable.getDataSourceQuery();
	}


	_translation() {
		const translation = I18n.global().datatables;

		return {
			records: {
				processing: translation.processing,
				noRecords: translation.noRecords
			},
			toolbar: {
				pagination: {
					items: {
						default: {
							first: translation.first,
							prev: translation.previous,
							next: translation.next,
							last: translation.last,
							more: translation.more,
							input: translation.input,
							select: translation.select
						},
						info: translation.info
					}
				}
			}
		};
	}

	initialize() {
		this.defaultDatatableInit();
	}
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/datatable.js